import App from '@/models/App'

export default class OrderingAddressBook extends App {
    static get entity() {
        return 'OrderingAddressBooks'
    }

    static all() {
        return this.query().get();
    }

    static fetch(type) {
        return this.query().where('type', type).get();
    }

    static fields() {
        return {
            id: this.attr(''),
            organizationId: this.attr(''),
            userId: this.attr(''),
            type: this.attr(''),
            value: this.attr(''),
            createdAt: this.attr(''),
            updatedAt: this.attr('')
        }
    }

    static apiConfig = {
        actions: {
            fetch(orderingShipId, params) {
                return this.get(
                    `/ordering/orderer/${orderingShipId}/address/books`,
                    {
                        params: App.get(params),
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            create(orderingShipId, params) {
                return this.post(
                    `/ordering/orderer/${orderingShipId}/address/books`,
                    App.get(params),
                    {
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
